<siat-header></siat-header>
<siat-sidebar
  [isCollapsed]="isSidebarCollapsed"
  (toggleSidebar)="onSidebarToggled()"
>
  <siat-app-bar></siat-app-bar>
  <div class="bg-[#FBFAFC] rounded-b-[30px] px-4 py-1" role="none">
    <router-outlet></router-outlet>
  </div>
</siat-sidebar>

<!-- Global Drawer - Fixed on the right, above everything -->
@if (drawerService.isOpen()) {
  <div
    class="global-drawer-backdrop"
    tabindex="0"
    (keyup)="onBackdropClick()"
    (click)="onBackdropClick()"
  ></div>
}

<div
  class="global-drawer"
  [class.open]="drawerService.isOpen()"
  [style.width]="drawerService.config().width || '400px'"
>
  @if (drawerService.isOpen()) {
    <div class="drawer-wrapper">
      <siat-drawer-container></siat-drawer-container>
    </div>
  }
</div>
